import React from "react";
import axios from "axios";
import { BASE_URL, COLLECTIONS, HEADERS, PARAMETERS, MATERIALS, PILEHEIGHTS } from "../../common/api";
import TinyMCEEditor from "../../common/tiny";
import Select from "react-select";

export default class SingleCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data: {},
      status: "",
      options: [],
      inParameters: [],
      imagePreview: [],
      regions: [],
      materials: [],
      pileheights: [],
      regiolan_price: [],
    };
    this.myRef = React.createRef();
  }

  log = () => {
    if (this.myRef.current) {
      console.log(this.myRef.current.getContent());
    }
  };

  componentDidMount() {
    const { id } = this.state;
    axios.get(BASE_URL + COLLECTIONS + id, HEADERS).then((res) => {
      const data = res.data;
      const arr = [];
      const obj = {};
      // console.log(data, "collection data");
      Object.keys(data).forEach((item) => (obj[item] = data[item]));
      data.parameters.map((el) => {
        return arr.push({ value: el.id, label: el.nameRu });
      });
      this.setState({
        data: obj,
        status: res.status,
        inParameters: arr,
        imagePreview: data.image,
      });
    });
    axios.get(BASE_URL + PARAMETERS).then((res) => {
      const data = res.data;
      const arr = [];
      data.map((el) => {
        return arr.push({ value: el.id, label: el.nameRu });
      });
      this.setState({ options: arr });
    });
    axios.get(BASE_URL + "regions/").then((res) => {
      const data = res.data;
      // console.log(data, "regions");
      this.setState({ regions: data });
    });
    axios.get(BASE_URL + MATERIALS).then((res) => {
      const data = res.data;
      this.setState({ materials: data });
    });
    axios.get(BASE_URL + PILEHEIGHTS).then((res) => {
      const data = res.data;
      this.setState({ pileheights: data });
    });
    axios.get(BASE_URL + "collection-region-prices/" + "?collection_id=" + id).then((res) => {
      const data = res.data;
      this.setState({ regiolan_price: data });
    });
  }

  onUzTinyChange = (content) => {
    this.setState({ data: { ...this.state.data, descriptionUz: content } });
    // this.setState({ textUz: content });
  };
  onRuTinyChange = (content) => {
    this.setState({ data: { ...this.state.data, descriptionRu: content } });
  };

  handleChange = (event) => {
    const data = {};
    data[event.target.name] = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  handleSelect = (event, stateProp) => {
    if (stateProp === "inParameters") {
      const arr = [];
      event.map((item) => {
        arr.push({ value: item.value, label: item.label });
        return arr;
      });
      this.setState({ [stateProp]: arr });
    } else {
      console.log(event, stateProp)
      this.setState({ [stateProp]: event });
    }
  };

  handleRegionPercentChange = (regionId, value) => {
    this.setState(prevState => ({
      regiolan_price: prevState.regiolan_price.map(item =>
        item.region_id === regionId
          ? { ...item, percent: value === "" ? null : Number(value) }
          : item
      )
    }));
  };

  onImageChange = (event) => {
    const file = event.target.files[0];
    // console.log(file);
    this.setState({
      data: {
        ...this.state.data,
        image: file,
      },
    });
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.setState({ imagePreview: reader.result });
    };
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { data, id, inParameters, material, pileHeight } = this.state;
    const selectedParams = [];
    if (!material) {
      alert("Пожалуйста, выберите материал");
      return;
    }
    
    if (!pileHeight) {
      alert("Пожалуйста, выберите высоту ворса");
      return;
    }
    if (!data.price){
      alert("Пожалуйста, заполните поля 'Цена'");
      return;
    }
    data.material = material.value
    data.pileHeight = pileHeight.value
    const formData = new FormData();
    // Append the image to the formData only if it exists and has a name property
    if (data.image !== null && data.image.name) {
      formData.append("image", data.image, data.image.name);
    }

    inParameters.map((param) => {
      formData.append("parameters", param.value);
    });

    for (let key in data) {
      if (key !== "image" && key !== "parameters" && data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`, "formdata");
    // }

    axios
      .patch(BASE_URL + COLLECTIONS + "put/" + id + "/", formData, HEADERS)
      .then(this.props.history.goBack())
      .catch((err) => {
        console.log(err);
        console.log(err.message);
        console.log(err.response);
      });
  };

  saveRegionPrices = () => {
    const { id, regiolan_price } = this.state;

    const payload = {
      collection_id: id,
      prices: regiolan_price.map(item => ({
        region_id: item.region_id,
        percent: item.percent
      }))
    };
    console.log(payload, "payload to be sent for region prices");

    axios
      .patch(
        BASE_URL + "collection-region-prices/bulk-update/",
        payload,
        HEADERS
      )
      .then(() => {
        alert("Цены по регионам сохранены");
      })
      .catch(err => {
        console.error(err);
        alert("Ошибка при сохранении цен");
      });
  };

  render() {
    const { data, status, options, inParameters, imagePreview, materials, pileheights, regiolan_price } = this.state;
    // console.log(regiolan_price, "regiolan_price");
    return (
      <>
        {status === 200 && (
          <div className="">
            <div className="tabs effect-3">
              <input
                type="radio"
                id="tab-1"
                name="tab-effect-3"
                defaultChecked="checked"
              />
              <span>Главная</span>
              <input type="radio" id="tab-2" name="tab-effect-3" />
              <span>Контент</span>
              <div className="line ease"></div>
              <div className="tab-content">
                <section id="tab-item-1">
                  <div className="design-card">
                    <div className="design-info">
                      <div className="design-key">Коллекция:</div>
                      <div className="design-value">{data.nameUz}</div>
                    </div>
                    <div className="design-info">
                      <div className="design-key">Категория:</div>
                      <div className="design-value">{data.category_nameRu}</div>
                    </div>
                  </div>
                  <div className="design-card">
                    <div className="row">
                      <div className="col-12">
                        <h6>Тип</h6>
                        <select
                          className="form-control"
                          aria-label="Default select example"
                          onChange={this.handleChange}
                          value={data.isMain}
                          name="isMain"
                        >
                          <option value="true">Топ</option>
                          <option value="false">Простой</option>
                        </select>
                      </div>
                    </div>
                    <div className="row pt-4">
                      <div className="col-6 ">
                        <h6>Статус</h6>
                        <select
                          className="form-control"
                          aria-label="Default select example"
                          onChange={this.handleChange}
                          value={data.isActive}
                          name="isActive"
                        >
                          <option value="true">Актив</option>
                          <option value="false">Пассив</option>
                        </select>
                      </div>
                      <div className="col-6">
                        <h6>isNew</h6>
                        <select
                          className="form-control"
                          aria-label="Default select example"
                          value={data.isNew}
                          onChange={this.handleChange}
                          name="isNew"
                        >
                          <option value="true">new</option>
                          <option value="false">NOT new</option>
                        </select>
                      </div>
                    </div>
                    <div className="row pt-4">
                      <div className="col-6">
                        <label htmlFor="materials-select">Маиериал*</label>
                        <Select
                          closeMenuOnSelect={false}
                          defaultValue={
                            materials
                              .map(material => ({
                                value: material.id,
                                label: material.name
                              }))
                              .find(option => option.value === data.material)
                          }
                          placeholder="Выберите..."
                          onChange={(event) =>
                            this.handleSelect(event, "material")
                          }
                          name="material"
                          options={materials.map(material => ({
                            value: material.id,
                            label: material.name
                          }))}
                        />
                    </div>
                      <div className="col-6">
                        <label htmlFor="pileHeights-select">Высота ворса*</label>
                        <Select
                          closeMenuOnSelect={false}
                          defaultValue={
                            pileheights
                              .map(pileheight => ({
                                value: pileheight.id,
                                label: pileheight.title
                              }))
                              .find(option => option.value === data.pileHeight)
                          }
                          // isMulti
                          placeholder="Выберите..."
                          onChange={(event) =>
                            this.handleSelect(event, "pileHeight")
                          }
                          name="pileheight"
                          options={pileheights.map(pileheight => ({
                            value: pileheight.id,
                            label: pileheight.title
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="design-card mt-4">
                    <h5>Цены по регионам (%)</h5>      
                    <table className="table table-bordered mt-3">
                      <thead>
                        <tr>
                          <th>Регион</th>
                          <th style={{ width: "200px" }}>Процент</th>
                        </tr>
                      </thead>
                      <tbody>
                        {regiolan_price.map(item => (
                          <tr key={item.region_id}>
                            <td>{item.region_name}</td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                min="0"
                                max="100"
                                value={item.percent ?? ""}
                                onChange={e =>
                                  this.handleRegionPercentChange(
                                    item.region_id,
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                      
                    <button
                      className="btn btn-primary mt-3"
                      onClick={this.saveRegionPrices}
                    >
                      Сохранить цены
                    </button>
                  </div>
                  <div className="design-card row">
                    <div className="col-6">
                      <h6>Цена*</h6>
                      <input
                        className="form-control"
                        aria-label="Default select example"
                        defaultValue={data.price}
                        onChange={this.handleChange}
                        name="price"
                      />
                    </div>
                    <div className="col-6">
                      <h6>Скидка</h6>
                      <input
                        className="form-control"
                        aria-label="Default select example"
                        defaultValue={data.discount}
                        onChange={this.handleChange}
                        name="discount"
                      />
                    </div>
                  </div>
                  <div className="filters buttons">
                    <button
                      className="btn btn-primary m-2"
                      onClick={(event) => this.handleSubmit(event)}
                    >
                      Крепить ко всем дизайнам
                    </button>
                    <button
                      className="btn btn-primary m-2"
                      onClick={(event) => this.handleSubmit(event)}
                    >
                      Сохранить
                    </button>
                  </div>
                </section>
                <section id="tab-item-2">
                  <div className="filters">
                    <div className="row m-1">
                      <div>
                        {data.image && (
                          <img
                            src={imagePreview}
                            alt="ifoto"
                            className="img-fluid pr-2"
                            style={{ width: "200px", height: "200px" }}
                          />
                        )}
                      </div>
                      <div className="file-upload">
                        <label htmlFor="file-input">
                          <i className="fa-regular fa-image fa-2xl pr-2"></i>{" "}
                          Загрузить фото
                        </label>
                        <input
                          type="file"
                          className="form-control-file"
                          id="file-input"
                          name="image"
                          onChange={this.onImageChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <form>
                          <div className="form-group">
                            <label htmlFor="textInput">Tasnif Uz</label>
                            <TinyMCEEditor
                              changed={this.onUzTinyChange}
                              value={data.descriptionUz}
                              name="descriptionUz"
                            />
                            {/* <CKEditorComponent
                              changed={this.onUzTinyChange}
                              value={data.descriptionUz}
                              name="descriptionUz"
                            /> */}
                          </div>
                        </form>
                      </div>
                      <div className="col-12">
                        <form>
                          <div className="form-group">
                            <label htmlFor="textInput">Описание Ru</label>
                            <TinyMCEEditor
                              changed={this.onRuTinyChange}
                              value={data.descriptionRu}
                              name="descriptionRu"
                            />
                            {/* <CKEditorComponent
                              changed={this.onRuTinyChange}
                              value={data.descriptionRu}
                              name="descriptionRu"
                            /> */}
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <label htmlFor="parameters">Параметры</label>
                        <Select
                          closeMenuOnSelect={false}
                          defaultValue={inParameters}
                          isMulti
                          placeholder="Выберите..."
                          onChange={(event) =>
                            this.handleSelect(event, "inParameters")
                          }
                          name="inParameters"
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="filters">
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="densityRu">Плотность</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.densityRu}
                              name="densityRu"
                              id="densityRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="densityUz">Zichlik</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.densityUz}
                              name="densityUz"
                              id="densityUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="basisRu">Основа</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.basisRu}
                              name="basisRu"
                              id="basisRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="basisUz">Asosi</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={data.basisUz}
                              name="basisUz"
                              placeholder="Kiriting..."
                              id="basisUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="pileHeightRu">Высота ворса</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.pileHeightRu}
                              name="pileHeightRu"
                              id="pileHeightRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="pileHeightUz">Qalinligi</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.pileHeightUz}
                              name="pileHeightUz"
                              id="pileHeightUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="pileThreadRu">Ворсовая нить</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.pileThreadRu}
                              name="pileThreadRu"
                              id="pileThreadRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="pileThreadUz">Ipning turi</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.pileThreadUz}
                              name="pileThreadUz"
                              id="pileThreadUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div> */}
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="threadCompositionRu">
                            Структура полотна
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.threadCompositionRu}
                              name="threadCompositionRu"
                              id="threadCompositionRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="threadCompositionUz">
                              Ipning tarkibi
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.threadCompositionUz}
                              name="threadCompositionUz"
                              id="threadCompositionUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="weightRu">Масса</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.weightRu}
                              name="weightRu"
                              id="weightRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="weightUz">Og'irligi</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.weightUz}
                              name="weightUz"
                              id="weightUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="edgeProcessingRu">
                            Обработка краев
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.edgeProcessingRu}
                              name="edgeProcessingRu"
                              id="edgeProcessingRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="edgeProcessingUz">
                              Yoniga ishlov berish xususiyati
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.edgeProcessingUz}
                              name="edgeProcessingUz"
                              id="edgeProcessingUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="designRu">Дизайн</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.designRu}
                              name="designRu"
                              id="designRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="designUz">Dizayn</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Kiriting..."
                              defaultValue={data.designUz}
                              name="designUz"
                              id="designUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div> */}
                    <div className="row">
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="serviceRu">Уход</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Введите..."
                              defaultValue={data.serviceRu}
                              name="serviceRu"
                              id="serviceRu"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="col-6">
                        <form>
                          <div className="form-group">
                            <label htmlFor="serviceUz">
                              Tozalash vositalari
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={data.serviceUz}
                              name="serviceUz"
                              placeholder="Kiriting..."
                              id="serviceUz"
                              onChange={this.handleChange}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={(event) => this.handleSubmit(event)}
                  >
                    Сохранить
                  </button>
                </section>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
